module.exports = __webpack_public_path__ + "static/media/overview.f8409688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/overview.jpg
// module id = 95
// module chunks = 0